const MESSENGER_AVATAR_PALETTE = [
    '#E53935',
    '#D81B60',
    '#8E24AA',
    '#5E35B1',
    '#3949AB',
    '#1E88E5',
    '#039BE5',
    '#00897B',
    '#43A047',
    '#7CB342',
    '#F4511E',
    '#E67C13',
    '#FB8C00',
    '#6D4C41',
    '#546E7A',
    '#C62828',
    '#AD1457',
    '#6A1B9A',
    '#4527A0',
    '#283593',
    '#1565C0',
    '#0277BD',
    '#00695C',
    '#2E7D32',
    '#558B2F',
    '#BF360C',
    '#E65100',
    '#F57F17',
    '#37474F',
    '#00838F',
    '#2196F3',
    '#880E4F',
] as const;

function djb2(value: string): number {
    let hash = 0;
    for (let i = 0; i < value.length; i++) {
        hash = Math.trunc((hash << 5) - hash + (value.codePointAt(i) ?? 0));
    }
    return Math.abs(hash);
}

export function getAvatarColor(name: string): string {
    return (
        MESSENGER_AVATAR_PALETTE[djb2(name.trim().toLowerCase()) % MESSENGER_AVATAR_PALETTE.length] ?? MESSENGER_AVATAR_PALETTE[0]
    );
}

export function getInitials(name: string): string {
    const [firstWord = '', secondWord] = name.trim().split(/\s+/);
    if (secondWord) {
        return `${firstWord.charAt(0)}${secondWord.charAt(0)}`.toUpperCase();
    }
    return firstWord.slice(0, 2).toUpperCase();
}
